import { CHECK_EMAIL_REMINDER_PARAM } from "@components/collapsible-header/CollapsibleHeader";
import getStore from "src/utils/redux/store";
import { createForwardParams } from "src/utils/urlParams";
import { reroll, setParam, synchronizeUpid } from "./utils";

export default {
  referral({ showEmailReminder }: { showEmailReminder?: boolean }) {
    const queryParams = createForwardParams();
    synchronizeUpid(queryParams, getStore());
    setParam(queryParams, CHECK_EMAIL_REMINDER_PARAM, showEmailReminder);
    reroll("/referral", queryParams);
  },
};
